import React, { FunctionComponent } from "react";
import { useAppRouter } from "../../providers";
import OriginalNextLink, { LinkProps } from "next/link";

export const NextLink: FunctionComponent<
  Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> &
    LinkProps & {
      children?: React.ReactNode;
    } & React.RefAttributes<HTMLAnchorElement>
> = ({ href, onClick, ...props }) => {
  const router = useAppRouter();
  return (
    <OriginalNextLink
      {...props}
      href={href}
      onClick={(event) => {
        if (typeof href === "string") {
          router.pathname = href;
        }
        onClick?.(event);
      }}
    >
      {props.children}
    </OriginalNextLink>
  );
};
